import { SortModelItem } from 'ag-grid-community';
import { RowHeights } from '@core/config/row-heights';
import { RequestedResourceRow } from '@core/models/requested-resource-row.model';
import { Classification } from '@portal-shared/app/entities/class.model';
import { Department } from '@portal-shared/app/entities/department.model';
import { ResourceGroupRowDto } from '@services/dtos/rows/resource-group-row.dto';
import { ResourceLikeDto } from '@services/dtos/rows/resource-like.dto';
import { AssignmentGroupDefinition } from '@services/models/group-definition.model';
import { PlanningBoardGroupRowType } from '@shared/components/grids/rows/groups/planning-board-group-row-type.enum';
import { PlanningGroupRow } from './planning-group.row';

export class ResourceGroupRow extends PlanningGroupRow {
  public override type = PlanningBoardGroupRowType.Resource;
  public override label = this.dto.name;
  public override height = RowHeights.planningGrid.rowLarge;
  public override isRowDroppable = true;
  public override styleClasses = ['p-use-custom-expand-button', `r-${this.dto.code}`];

  public classification: Classification;
  public department: Department;

  public constructor(
    public dto: ResourceGroupRowDto,
    public request: RequestedResourceRow | undefined,
    public override resourceId: string = dto.resourceId
  ) {
    super(dto, undefined, undefined, undefined, resourceId); // the row gives no planning (assignment) information about project, department or class, only for the resource.

    this.classification = new Classification(dto.defaultClassId, dto.defaultClassCode, dto.defaultClassDescription);
    this.department = new Department(dto.departmentId, dto.departmentCode, dto.departmentDescription);
  }

  public override toGroupDefinition(): AssignmentGroupDefinition {
    return {
      resourceId: this.resourceId
    };
  }

  public toResourceLikeDto(): ResourceLikeDto {
    return {
      id: this.resourceId,
      name: this.dto.name,
      code: this.dto.code,
      email: this.dto.email,
      classCode: this.dto.defaultClassCode,
      classDescription: this.dto.defaultClassDescription,
      departmentId: this.dto.departmentId,
      departmentCode: this.dto.departmentCode,
      departmentDescription: this.dto.departmentDescription,
      capacity: this.dto.capacity,
      workEnded: this.dto.workEnded
    };
  }

  public static getDefaultSortModel(): SortModelItem[] {
    return [{ colId: 'resourceName', sort: 'asc' }];
  }
}
